import { render, staticRenderFns } from "./MentoringSteps.vue?vue&type=template&id=179356bf&scoped=true"
import script from "./MentoringSteps.vue?vue&type=script&lang=js"
export * from "./MentoringSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179356bf",
  null
  
)

export default component.exports